import script from "./ClientTools.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientTools.vue?vue&type=script&setup=true&lang=ts"

import "./ClientTools.vue?vue&type=style&index=0&id=32adb805&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32adb805"]])

export default __exports__